import $ from 'Vendor/jquery'
import {Zero, Broadcast, Logger, Components} from 'Zero';
import {GoogleMap} from 'Vendor/@openmind/storelocator/dist/googlemap.umd.js';


const Log = new Logger("WE_ZMap");

export default class ZMap extends Components {


  get Messages() {
    return {
      "StoreLocator:Init": this.onStoreLocatorInit,
      "StoreLocator:GeoJson:Loaded": this.onGeoJsonLoaded,
      "StoreLocator:Pin:Clicked": this.onClickedLightPin,
      "StoreLocator:Pin:Unclicked": this.onUnclickedLightPin,
      "StoreLocator:Pin:Hover": this.onHoverLightPin,
      "StoreLocator:Pin:Unhover": this.onUnhoverLightPin,
      "StoreLocator:List:Clicked": this.onClickedLightPin,
      "StoreLocator:List:Unclicked": this.onUnclickedLightPin,
      "StoreLocator:List:Hover": this.onHoverLightPin,
      "StoreLocator:List:Unhover": this.onUnhoverLightPin
    };
  }

  get Selectors() {
    return {
      Map: "#map-container",
      ZoomIn: "#controls_zoom_in",
      ZoomOut: "#controls_zoom_out"
    }
  }


  get react() {
    return {
      onLocationChange: () => {
        var location = Zero.$state.StoreLocator.Location;
        var bounds = location && location.Bounds;
        if ( location && bounds ) {
          this.StoreLocator.navigateLocation( bounds ).then( () => {
            Log.i("Map has navigated");
            this.CAST("StoreLocator:Map:Navigated", {bounds});
          });
        }
      }
    }
  }

  constructor(element) {
    super(element);

    this.element.find( this.Selectors.ZoomIn ).on("click.zmap", () => {
      this.StoreLocator.zoom = 1;
    });

    this.element.find( this.Selectors.ZoomOut ).on("click.zmap", () => {
      this.StoreLocator.zoom = -1;
    });

    this.MapEl = this.element.find( this.Selectors.Map );

    this.data.marker = this.data.marker || {};

  }


  onStoreLocatorInit(msg) {

    this.StoreLocator = msg.StoreLocator;

    Log.info("Got storelocator for", this.element);

    //  const _styles = [{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}];
    const _styles = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative","stylers":[{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural.terrain","stylers":[{"color":"#e6e6e6"},{"visibility":"on"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];

    this.data.map = this.data.map || {};
    this.data.map.styles = _styles;
    this.data.map.disableDefaultUI = true;
    this.data.map.scaleControl = true;
    this.data.map.fullscreenControl = false;
    this.data.map.gestureHandling = 'cooperative';

    this.PromiseMap = new GoogleMap(this.StoreLocator, this.MapEl, this.data.map );

    this.PromiseMap.then( (gmap) => {

      this.StoreLocator.addMapEngine('GoogleMap', this.GMap = gmap );

      this.bindStoreLocator();

      this.onLocationChange();

      this.CAST("StoreLocator:Map:Ready", {map: gmap});

    }, function() {
      Log.error("Cannot bind GMap engine", arguments);
      throw "Cannot bind GMap engine";
    });

  }

  onGeoJsonLoaded(msg) {
    const inCart = document.body.classList.contains('t-cart');
    let geojson = msg.geojson;

    this.PromiseMap.then(() => {
      this.StoreLocator.showPoint(geojson, !!this.data.usecluster).then((markers) => {
        for (let marker of markers) {
          if (inCart) {
            if (marker.data.features.hasOwnProperty('CLICK_AND_COLLECT')) {
              this.bindMarker(marker);
            }
          } else {
            if (!marker.data.storeHidden) {
              this.bindMarker(marker);
            }
          }
        }
      });
    });
  }

  bindMarker(marker) {

    marker.label = {
      text : marker.storeData._labelindex,
      color : marker.storeData._labelcolor,
      fontSize : '10px'
    }

    marker.title = marker.storeData.displayName;

    marker.on('mouseover', () => {
      this.CAST( "StoreLocator:Pin:Hover", {marker: marker});
    });

    marker.on('mouseout', () => {

      let markerCode = marker.getKey();
      if ( this.PinHasBeenClicked ){
        if ( markerCode !== this.PrevMarkerCode ) {
          this.CAST( "StoreLocator:Pin:Unhover", {marker: marker});
        }
      } else {
        this.CAST( "StoreLocator:Pin:Unhover", {marker: marker});
      }

    });

    marker.on('click', () => {

      let markerCode = marker.getKey();

      if ( this.PrevMarkerCode ) {
        let prev_marker = this.StoreLocator.getMarker(this.PrevMarkerCode);
        if ( prev_marker ){
          this.CAST( "StoreLocator:Pin:Unclicked", {marker: prev_marker});
        }
      }

      if( this.PinHasBeenClicked = (markerCode !== this.PrevMarkerCode) ) {
        this.CAST( "StoreLocator:Pin:Clicked", {marker: marker});
      }
    });

    if ( this.data.marker && this.data.marker.icon ) {

      marker.image = this.data.marker.icon;
    }
  }


  bindStoreLocator() {
    this.StoreLocator.on("moveinmap.zmap navigateTo.zmap", (e, map) => {
      Log.i("Map has been moved");
      Zero.$state.StoreLocator.Map.Center = map.center;
      Zero.$state.StoreLocator.Map.Bounds = map.bounds;
    });

    this.StoreLocator.on("mapzoom.zmap mappan.zmap", (e, map) => {
      this.CAST("StoreLocator:Map:Moved", {center: map ? map.center : null, bounds: map ? map.bounds : null});
    });

  }


  onClickedLightPin(msg) {
    let marker = msg.marker;

    this.PrevMarkerCode = marker.getKey();
    if ( this.data.marker && this.data.marker.iconhover ) {
      marker.image = this.data.marker.iconhover;
    }

  }

  onUnclickedLightPin(msg) {
    let marker = msg.marker;
    if ( marker ) {
      if ( this.data.marker && this.data.marker.icon ) {
        marker.image = this.data.marker.icon;
      }
    }

    this.PrevMarkerCode = "";
  }


  onHoverLightPin(msg) {
    let marker = msg.marker;
    if ( this.data.marker && this.data.marker.iconhover ) {
      marker.image = this.data.marker.iconhover;
    }

    if ( marker.cluster && marker.cluster.clusterIcon_ && marker.cluster.clusterIcon_.div_ ) {
      $(marker.cluster.clusterIcon_.div_).addClass(`cluster${marker.cluster.clusterIcon_.index_ - 1}-hov`);
    }

  }

  onUnhoverLightPin(msg) {
    let marker = msg.marker;
    if ( this.data.marker && this.data.marker.icon ) {
      marker.image = this.data.marker.icon;
    }

    if ( marker.cluster && marker.cluster.clusterIcon_ && marker.cluster.clusterIcon_.div_ ) {
      $(marker.cluster.clusterIcon_.div_).removeClass(`cluster${marker.cluster.clusterIcon_.index_ - 1}-hov`);
    }

  }
}

export {
  ZMap
}
